const routes = [
  {
    path: '/cadastro/servicos/setor',
    name: 'sector',
    component: () => import('@/views/cadastros/setor/Setor.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Servicos' }, { title: 'Setores' }],
    },
  },
  {
    path: '/cadastro/servicos/setor/novo',
    name: 'sectorNew',
    component: () => import('@/views/cadastros/setor/SetorNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Servicos' }, { title: 'Setores' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/servicos/setor/:id/editar',
    name: 'sectorUpdate',
    component: () => import('@/views/cadastros/setor/SetorNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Servicos' }, { title: 'Setores' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/grupo-servico',
    name: 'serviceGroup',
    component: () => import('@/views/cadastros/grupoServico/GrupoServico.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Tipos de Serviço' }],
    },
  },
  {
    path: '/cadastro/geral/grupo-servico/novo',
    name: 'serviceGroupNew',
    component: () => import('@/views/cadastros/grupoServico/GrupoServicoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Tipos de Serviço' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/grupo-servico/:id/editar',
    name: 'serviceGroupUpdate',
    component: () => import('@/views/cadastros/grupoServico/GrupoServicoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Tipos de Serviço' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/logradouro',
    name: 'logradouro',
    component: () => import('@/views/cadastros/logradouro/Logradouro.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Logradouro' }],
    },
  },
  {
    path: '/cadastro/geral/logradouro/novo',
    name: 'logradouroNew',
    component: () => import('@/views/cadastros/logradouro/LogradouroNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Logradouro' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/logradouro/:id/editar',
    name: 'logradouroUpdate',
    component: () => import('@/views/cadastros/logradouro/LogradouroNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Logradouro' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/logradouro/:id/visualizar',
    name: 'logradouroView',
    component: () => import('@/views/cadastros/logradouro/LogradouroNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Logradouro' }],
      type: 'view',
    },
  },
  {
    path: '/cadastro/geral/area-complexidade-urbana',
    name: 'areaComplexidade',
    component: () => import('@/views/cadastros/areaComplexidade/AreaComplexidade.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Área de Complexidade Urbana' }],
    },
  },
  {
    path: '/cadastro/geral/area-complexidade-urbana/novo',
    name: 'areaComplexidadeNew',
    component: () => import('@/views/cadastros/areaComplexidade/AreaComplexidadeNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Área de Complexidade Urbana' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/area-complexidade-urbana/:id/editar',
    name: 'areaComplexidadeUpdate',
    component: () => import('@/views/cadastros/areaComplexidade/AreaComplexidadeNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Área de Complexidade Urbana' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/area-complexidade-urbana/:id/visualizar',
    name: 'areaComplexidadeView',
    component: () => import('@/views/cadastros/areaComplexidade/AreaComplexidadeNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Área de Complexidade Urbana' }],
      type: 'view',
    },
  },
  {
    path: '/cadastro/geral/bairro',
    name: 'bairro',
    component: () => import('@/views/cadastros/bairro/Bairro.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Bairro' }],
    },
  },
  {
    path: '/cadastro/geral/bairro/novo',
    name: 'bairroNew',
    component: () => import('@/views/cadastros/bairro/BairroNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Bairro' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/bairro/:id/editar',
    name: 'bairroUpdate',
    component: () => import('@/views/cadastros/bairro/BairroNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Bairro' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/bairro/:id/visualizar',
    name: 'bairroView',
    component: () => import('@/views/cadastros/bairro/BairroNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Bairro' }],
      type: 'view',
    },
  },
  {
    path: '/cadastro/geral/regiao',
    name: 'regiao',
    component: () => import('@/views/cadastros/regiao/Regiao.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Regiões' }],
    },
  },
  {
    path: '/cadastro/geral/regiao/novo',
    name: 'regiaoNew',
    component: () => import('@/views/cadastros/regiao/RegiaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Região' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/regiao/:id/editar',
    name: 'regiaoUpdate',
    component: () => import('@/views/cadastros/regiao/RegiaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Região' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/regiao/:id/visualizar',
    name: 'regiaoView',
    component: () => import('@/views/cadastros/regiao/RegiaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Região' }],
      type: 'view',
    },
  },
  {
    path: '/cadastro/geral/tipo-os',
    name: 'osType',
    component: () => import('@/views/cadastros/tipoOs/TipoOs.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Sabesp' }, { title: 'Tipos de OS' }],
    },
  },
  {
    path: '/cadastro/geral/tipo-os/novo',
    name: 'osTypeNew',
    component: () => import('@/views/cadastros/tipoOs/TipoOsNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Sabesp' }, { title: 'Tipos de OS' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/tipo-os/:id/editar',
    name: 'osTypeUpdate',
    component: () => import('@/views/cadastros/tipoOs/TipoOsNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Sabesp' }, { title: 'Tipos de OS' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/lote',
    name: 'lot',
    component: () => import('@/views/cadastros/lote/Lote.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Sabesp' }, { title: 'Lotes' }],
    },
  },
  {
    path: '/cadastro/geral/lote/novo',
    name: 'lotNew',
    component: () => import('@/views/cadastros/lote/LoteNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Sabesp' }, { title: 'Lotes' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/lote/:id/editar',
    name: 'lotUpdate',
    component: () => import('@/views/cadastros/lote/LoteNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Sabesp' }, { title: 'Lotes' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/servicos-spo',
    name: 'spoService',
    component: () => import('@/views/cadastros/servicoSpo/ServicoSpo.vue'),
    meta: {
      breadcrumb: [{ title: 'Saneamento' }, { title: 'Sabesp' }, { title: 'Serviços SPO' }],
    },
  },
  {
    path: '/cadastro/geral/servicos-spo/novo',
    name: 'spoServiceNew',
    component: () => import('@/views/cadastros/servicoSpo/ServicoSpoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Saneamento' }, { title: 'Sabesp' }, { title: 'Serviços SPO' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/servicos-spo/:id/editar',
    name: 'spoServiceUpdate',
    component: () => import('@/views/cadastros/servicoSpo/ServicoSpoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Saneamento' }, { title: 'Sabesp' }, { title: 'Serviços SPO' }, { title: 'Editar' }],
    },
  },
]

export default routes
